import { cartInitialState } from './cart.state';
import { CartActionsUnion, CartActionTypes } from './cart.actions';

export function cartReducer(state = cartInitialState, action: CartActionsUnion) {
  switch (action.type) {
    case CartActionTypes.ADD_TO_CART:
      return {...state, loading: true, error: null};
    case CartActionTypes.ADD_TO_CART_SUCCESS:
      return {...state, loading: false, error: null};
    case CartActionTypes.ADD_TO_CART_FAILURE:
      return {...state, loading: false, error: action.payload.error};

    case CartActionTypes.GET_CART_TOTAL_QUANTITY_SUCCESS:
      return {...state, payload: {itemsInCart: action.payload.count}};
    case CartActionTypes.GET_CART_TOTAL_QUANTITY_FAILURE:
      return {...state, payload: {itemsInCart: null}, error: action.payload.error};
    case CartActionTypes.SHOW_MINI_CART:
      return {
        ...state,
        showMiniCart: true
      };
    case CartActionTypes.CLOSE_MINI_CART:
      return {
        ...state,
        showMiniCart: false
      };
    default:
      return state;
  }
}
